'use client'

import { SpriteSheet } from '@/shared/ui'

export const IconProvider = () => {
  return SpriteSheet
}
